// extracted by css-extract-rspack-plugin
export default {"ctaContainer":"I08mO","ctaSubtitle":"hRbQd","title":"JAZ2F"};